import { Component, OnInit, HostBinding, ViewEncapsulation, Input } from '@angular/core';
import { MFormation, MSession } from '@argalis-apps/models';
import { CartService } from '../../services/cart/cart.service';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddToCartComponent {
  @HostBinding('class') themeFlag: string;
  @Input('formation')
  set _formation(value: MFormation.IFormInfo) {
    if (value) {
      this.formation = value;
      this.alreadyInCart();
      this.alreadyInCartSubscribe();
    }
  }
  @Input() session: MSession.ISessionInfo;
  public modalite;
  @Input('modalite')
  set _modalite(value) {
    this.modalite = value;
  }

  private formation: MFormation.IFormInfo;
  public numberAlreadyAdded = 0;
  public doneAdding: boolean;
  public loading: boolean;

  constructor(
    private cartService: CartService,
    private authService: AuthService,
    cartConfigService: CartConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${cartConfigService.themingClassName} exported`;
  }

  // met à jour numberAlreadyAdded selon la donnée d'initialisation (requête serveur peut ne pas être terminé à ce moment là)
  async alreadyInCart() {
    if (this.formation) {
      const alreadyThere: any[] = await this.cartService.findElementsOfCart(this.formation.id);
      this.numberAlreadyAdded = alreadyThere.length;
    }
  }

  // écoute tout changement (i.e requête http) et met à jour numberAlreadyAdded
  async alreadyInCartSubscribe() {
    if (this.formation) {
      const getObservable = await this.cartService.findElementsOfCartSubscribe(this.formation.id);
      getObservable.subscribe(resa => {
        this.numberAlreadyAdded = resa.length;
      });
    }
  }

  async addToCart() {
    // récupère le nb de places, prix et participants
    if (this.formation) {
      this.loading = true;
      await this.cartService.addToCart(
        {
          id: 0,
          id_client: ((this.authService.userConnected || ({} as any)).company || ({} as any)).id || 0,
          formation: this.formation,
          session_list: this.formation.sessions,
          selected_session: this.session || null,
          participants: [],
          nb_places: 0,
          price: 0
        },
        this.modalite
      );
      this.loading = false;
      this.doneAdding = true;
    }
  }
}
